const API = {
  // MY SIFARISH API's
  ///admin

  ADMIN_LOGIN: `auth/adminLogin`,
  VERIFY_LOGIN: `auth/verifyAdminLogin`,
  MASRER_DATA: `master/getAllMasterData`,

  GET_USER_LIST: `user/getUsers`,
  GET_USER_DETAIL: `account/getUserDetail`,
  DELETE_USER_DATA: `admin/deleteUser`,
  EDIT_USER_DATA: "account/updateUserProfile",
  CREATE_USER_DATA: "admin/createUser ",
  GET_DELETED_USER_LIST: `admin/getDeletedUsers`,

  GET_USER_SIFARISH: "sifarish/getSifarishes",
  GET_USER_SIFARISH_DETAILS: "sifarish/getSifarishDetail",
  DELETE_USER_SIFARISH: "sifarish/deleteSifarish",
  TOGGLE_USER_ACTIVE: `admin/toggleUserActiveStatus`,
  UPLOAD_USERFILE: `fileManager/uploadFile`,
  ADD_USER_SIFARISH: "sifarish/addSifarish",
  UPDATE_USER_SIFARISH: "sifarish/updateSifarish",
  REPORTED_SIFARISH: "admin/getSifarishesWithDetail",
  USER_COMPLETE_SIFARISH: "admin/getUserCompleteSifarishData",
  UNDO_DELETE_SIFARISH: "admin/undoDeleteSifarish",
  GET_SIFARISH_POINTS: "account/getSifarishPointLogs",
  ADD_SIFARISH_POINTS: "admin/addSifarishPoints",
  EXPORT_FORWARD_SIFARISH: "admin/getForwardedSifarish",
  EXPORT_SAVED_SIFARISH: "admin/getSavedSifarish",
  EXPORT_REPORTED_SIFARISH_USER: "admin/getUserListWhoReported",
  EXPORT_FORWARD_SIFARISH_USER: "admin/getUserListWhoForwarded",
  EXPORT_SAVED_SIFARISH_USER: "admin/getUserListWhoSaved",

  GET_CATEGORIES: "master/getCategories",
  ADD_CATEGORIES: "admin/addUpdateCategory",
  ADD_SUBCATEGORIES: "admin/addSubcategory",
  DELETE_CATEGORIES: "admin/deleteCategory",
  DELETE_SUBCATEGORIES: "admin/deleteSubcategory",

  GET_ACTIVE_SESSIONS: "admin/getSessionList",
  REMOVE_LOGIN_SESSIONS: "account/removeLoginSession",

  GET_APP_VERSION: "master/getSystemSettings",
  UPDATE_APP_VERSION: "admin/updateSystemSettings",

  UPDATE_BROADCAST: "admin/sendBroadcastMessage",
  SEND_BROADCAST_EMAIL: "admin/sendBroadcastEmail",
  BROADCAST_HISTORY_LIST: "admin/getBroadcastHistory",

  GET_USER_CONTACT: "contact/getAllContacts",

  GET_LEADERBOARD: "account/getCompleteLeaderboard",

  ACCEPT_BUSINESS_PROFILE_REQUEST: "admin/acceptBusinessProfileRequest",
  REJECT_BUSINESS_PROFILE_REQUEST: "admin/rejectBusinessProfileRequest",
  // MY SIFARISH API's
  ///admin
};

export default {
  ...API,
};
